import React from 'react';
import { Type, ButtonPrimary, spacer16, spacer56 } from '@spotify-internal/encore-web';
import styled from 'styled-components';

import { useTranslation } from 'providers/translations/TranslationProvider';
import analytics from 'utils/client/analytics/analytics';
import PageContainer from 'components/PageContainer';
import { UbiHomePage } from 'utils/ubi/pages/useUbiHome';
import { useServerSideConstants } from 'providers/ServerSideConstantsProvider';

const Content = styled.div`
  padding: ${spacer56} 0;
  text-align: center;
`;

export type CommunityProps = {
  ubi: UbiHomePage;
};

const Community = ({ ubi }: CommunityProps) => {
  const { t } = useTranslation();
  const {
    verticalConfig: { features },
  } = useServerSideConstants();
  const { communityLink } = features;

  if (!communityLink) {
    return null;
  }

  const trackClick = () => {
    analytics.trackEvent({
      category: 'community',
      action: 'click_community_link',
      label: 'home_page',
      value: undefined,
    });
    ubi.logCommunityLink(communityLink);
  };
  return (
    <PageContainer>
      <Content>
        <Type as="h2" variant="altoBrio" paddingBottom={spacer16}>
          {t('community_header')}
        </Type>
        <Type as="p" variant="ballad" paddingBottom={spacer16}>
          {t('community_intro')}
        </Type>
        <ButtonPrimary href={communityLink} onClick={trackClick} target="_blank" rel="noreferrer">
          {t('community_button')}
        </ButtonPrimary>
      </Content>
    </PageContainer>
  );
};
export default Community;
